// types
import type {
  Duty,
  EmployeeDutyData
} from 'RestAPIs/cost-centers/employees/types';

/**
 * Every duty on screen, flattened out of the employee → day → duty nesting the employees endpoint
 * returns. It feeds the duty code and duty hour type filter options, which look at the duties
 * themselves rather than at who works them.
 */
export const collectAllDuties = (employees?: EmployeeDutyData[]): Duty[] =>
  (employees ?? [])
    .filter((employee) => employee.days?.length)
    .flatMap((employee) => employee.days)
    .flatMap((day) => day?.duties ?? [])
    // a hole inside a `duties` array, not just a missing array: `getUniqueFilterValues` reads
    // `duty['displayDutyCode']` straight away and would take the roster screen down with it
    .filter((duty) => duty != null);
